import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import * as queryString from 'query-string';
import {
  Card,
  Hero,
  LoginForm,
  Notification,
  Title,
  RouteWrapper,
  Version,
  Section,
} from '../../components';
import { login, rejectLogin } from '../../redux/actions/auth';

interface Props {
  auth: any;
  handleLogin: Function;
}

const Route = ({ auth, handleLogin }: Props) => (
  <RouteWrapper requireNoAuth title="Login">
    <Hero className="is-small">
      <Title large>Login</Title>
    </Hero>
    <Section>
      <Card>
        <LoginForm handleLogin={handleLogin} disabled={auth.isFetching} />
      </Card>
      {!auth.isFetching &&
        auth.didInvalidate && (
          <Notification type="danger">{auth.error}</Notification>
        )}
      <div className="is-pulled-right">
        <Version />
      </div>
    </Section>
  </RouteWrapper>
);

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleLogin: (data) => {
    if (!data.email) {
      dispatch(rejectLogin('Please enter an email'));
    } else if (!data.password) {
      dispatch(rejectLogin('Please enter your password'));
    } else {
      const query = queryString.parse(window.location.search);
      dispatch(login(data.email, data.password)).then((response) => {
        if (!response.error) {
          if (query && query.redirect) {
            dispatch(push(query.redirect));
          } else {
            dispatch(push('/dashboard'));
          }
        }
      });
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Route);
